<template>
  <div class="form-body">
    <h4 class="form-section">
      <i class="icon-user"></i>{{ $t("labels.general") }}
    </h4>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="projectinput2">{{ $t("labels.email") }}</label>
          <input type="text" class="form-control" v-model="user.email">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="projectinput3">{{ $t("labels.password") }}</label>
          <input type="password" class="form-control" v-model="newPass.password">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="projectinput4">{{ $t("labels.language") }}</label>
          <select class="form-control" v-model="user.language">
            <option value="en" selected>English</option>
            <option value="it" selected>Italian</option>
            <option value="fr" selected>French</option>
            <option value="es" selected>Spanish</option>
            <option value="de" selected>German</option>
            <option value="nl" selected>Netherland</option>
            <option value="cr" selected>Croatian</option>
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="projectinput3">{{ $t("labels.passwordConfirmation") }}</label>
          <input type="password" class="form-control" v-model="newPass.confirmPassword">
        </div>
      </div>
    </div>
    <h4 class="form-section" v-if="$store.state.user.role === 'admin'">
      <i class="icon-book-open"></i>{{ $t("labels.permissions") }}
    </h4>
    <div class="row" v-if="$store.state.user.role === 'admin'">
      <div class="col-md-6">
         <div class="form-group">
            <label for="role">{{ $t("labels.role") }}</label>
            <select class="form-control" v-model="user.role">
              <option value="user" selected>User</option>
              <option value="dravetnet" selected>DravetNet</option>
              <option value="admin" selected>Admin</option>
            </select>
          </div>
      </div>
    </div>
    <h4 class="form-section">
      <i class="icon-book-open"></i>{{ $t("labels.registry") }}
    </h4>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="projectinput1">{{ $t("labels.firstName") }}</label>
          <input type="text" class="form-control" v-model="user.name">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="projectinput2">{{ $t("labels.lastName") }}</label>
          <input type="text" class="form-control" v-model="user.surname">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["user","newPass"]
}
</script>
